import React, { useEffect, FC } from 'react';

import { documentService } from '../../../utils/window.utils';
import selectors from '../constants/selectors';
import { TLoadAdvisorProps } from '../types/advisor.types';

const LoadAdvisor: FC<TLoadAdvisorProps> = (props) => {
  const { scriptUrl } = props;

  useEffect(() => {
    const loadScript = (src: string) =>
      new Promise((resolve, reject) => {
        const tag = documentService().createElement('script');
        tag.async = false;
        tag.id = selectors.advisorScriptId;
        tag.src = src;
        tag.onload = resolve;
        tag.onerror = reject;
        documentService().getElementsByTagName('body')[0].appendChild(tag);
      });

    const loadAdvisor = async () => {
      if (!scriptUrl?.value) return;
      await loadScript(scriptUrl?.value);
    };
    loadAdvisor();
  }, [scriptUrl]);

  return (
    <div id="xc_application" className="advisor">
      <div id="xc_application_pane"></div>
      <div id="xc_loader"></div>
    </div>
  );
};

export default LoadAdvisor;
